var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"follow-us"},[(typeof _vm.social_links == 'object')?_c('cmsBlockSimple',{attrs:{"identifier":_vm.social_links.identifier}}):_vm._e(),_c('div',{staticClass:"devider show-mobile"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }